export default __webpack_public_path__ + "static/media/img-0351-central-african-full-face.5ea3a50a.png";